/*
 * Rennsieger — count-up animation.
 *
 * Any element with [data-rsg-count] counts from 0 to data-count-to the first time it
 * scrolls into view (easeOutExpo). Honest numbers only — used for policy figures
 * (30-day returns, 12-month warranty, the $39.99 threshold), never fabricated metrics.
 *
 *   <span data-rsg-count data-count-to="30" data-count-suffix="-day">0</span>
 *
 * Optional: data-count-prefix, data-count-suffix, data-count-decimals, data-count-dur (ms).
 * No dependencies; no-ops when absent; respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-rsg-count]'));
  if (!nodes.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n, decimals, prefix, suffix) {
    var v = decimals > 0 ? n.toFixed(decimals) : String(Math.round(n));
    // thousands separators for whole numbers
    if (decimals === 0) v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (prefix || '') + v + (suffix || '');
  }

  function run(el) {
    var to = parseFloat(el.getAttribute('data-count-to')) || 0;
    var decimals = parseInt(el.getAttribute('data-count-decimals'), 10) || 0;
    var prefix = el.getAttribute('data-count-prefix') || '';
    var suffix = el.getAttribute('data-count-suffix') || '';
    var dur = parseInt(el.getAttribute('data-count-dur'), 10) || 1500;

    if (reduce) { el.textContent = fmt(to, decimals, prefix, suffix); return; }

    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(2, -10 * p); // easeOutExpo
      if (p >= 1) eased = 1;
      el.textContent = fmt(to * eased, decimals, prefix, suffix);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if (!('IntersectionObserver' in window)) {
    nodes.forEach(run);
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      run(entry.target);
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.4 });

  nodes.forEach(function (el) { obs.observe(el); });
})();
